import LocalStorage from "./LocalStorage";

type ShowInvoicesVariant = "A" | "B" | "X";

export const saveInvoicesStatus = (value: ShowInvoicesVariant) =>
  LocalStorage.setJSONValue("showInvoices", { value });

const getStoredInvoicesStatus = (): ShowInvoicesVariant | undefined =>
  LocalStorage.getJSONValue("showInvoices")?.value as ShowInvoicesVariant;

const getShowInvoicesFromUrl = (): ShowInvoicesVariant | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  const showInvoicesValue = urlParams.get("showInvoices")?.toUpperCase() || "";
  return ["A", "B", "X"].includes(showInvoicesValue)
    ? (showInvoicesValue as ShowInvoicesVariant)
    : undefined;
};

export const getShowInvoicesStatus = (): ShowInvoicesVariant => {
  const showInvoicesStatus =
    [getShowInvoicesFromUrl(), getStoredInvoicesStatus()].find((status) =>
      status && ["A", "B", "X"].includes(status) ? status : ""
    ) || "X";
  saveInvoicesStatus(showInvoicesStatus);
  return showInvoicesStatus;
};

export const isConsolidatedInvoicesEnabled = (): boolean =>
  getShowInvoicesStatus() === "A";
export const isAllInvoicesEnabled = (): boolean =>
  getShowInvoicesStatus() === "B";

export const isInvoicesEnabled = (): boolean =>
  ["A", "B"].includes(getShowInvoicesStatus());
